<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="appointmentIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a @click="urlTo('applyIndex')"  href="javascript:void(0)" >个人办事</a>  / <span>{{title}}申请</span></p></div>
          </div>
        </div>
        <div class="fixed">
        </div>
        <div class="wraper">
        </div>
        <div>
          <el-form  v-loading.fullscreen.lock="fullscreenLoading" :model="dataObj" :rules="rules" ref="dataObj" @submit="setAppointment" label-width="100px" class="demo-ruleForm">
            <div  class="wraper" style="background-color: white;padding-top: 3%;margin: 0 auto;">
              <table  width="90%" style="margin: 0 auto;" border="0" cellspacing="0" cellpadding="0" >
                <tr >
                  <td colspan="3" style="padding-bottom: 20px;">
                    <el-divider style="background-color: #b7b7b7; font-weight: 800;" content-position="left">基本信息</el-divider>
                  </td>
                </tr>
              <tr class="input_text">
                <el-form-item  label="办事单位:" prop="applyName">

                  <el-select    style="width: 250px" v-model="dataObj.applyName" placeholder="请选择">
                    <el-option

                      v-for="(item,index) in applyNameList"
                      @click.native="onApplyConfirm(item)"
                      :label="item.osiName"
                      :value="item.osiId"
                      :key="index+'faanml'"
                    >

                    </el-option>
                  </el-select>

                </el-form-item>
                <td width="4%">&nbsp;</td>
                <el-form-item   label="预约日期:" prop="at_date">
                  <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker
                      @change="subDate(dataObj.at_date)"
                      value-format="yyyyMMdd"
                      :picker-options="pickerOptions0"
                      style="width: 250px"
                      v-model="dataObj.at_date"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </div>
                </el-form-item>

              </tr>
              <tr>
                <td width="45%">
                <el-form-item label="业务分类:" prop="serviceCatagoryName">

                    <el-select   style="width: 250px"  v-model="dataObj.serviceCatagoryName"  placeholder="请选择">
                      <el-option
                        v-for="(item,index) in serviceCatagoryList"
                        :label="item.name"
                        :value="item.code"
                        :key="index+'fusc'"
                      >
                      </el-option>
                    </el-select>

                </el-form-item>
                </td>
                <td width="4%">&nbsp;</td>
                <td width="45%">
                  <el-form-item label="是否居家隔离人员:"  prop="horizontal">
                    <el-radio style="padding-top: 33px" v-model="dataObj.isolation" label="0">是</el-radio>
                    <el-radio v-model="dataObj.isolation" label="1">否</el-radio>
                  </el-form-item>
                </td>

              </tr>
              <tr>
                <td width="45%">
                  <el-form-item label="入园人数:" >
                    <el-input-number min="1" max="10" style="width: 250px" v-model="dataObj.people_num" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number>
                  </el-form-item>
                </td>
                <td width="4%">&nbsp;</td>
                <td width="45%">
                  <el-form-item  label="出行方式:" prop="travel_mode">
                    <template>
                      <el-select   style="width: 250px" v-model="dataObj.travel_mode" placeholder="请选择">
                        <el-option
                          v-for="(item,index) in travelModeList"
                          :label="item.name"
                          :value="item.code"
                          :key="index+'fa'"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </td>

              </tr>

                <tr >
                  <td colspan="3" style="padding-bottom: 20px;">
                    <el-divider style="background-color: #b7b7b7; font-weight: 800;" content-position="left">预约人信息</el-divider>
                  </td>
                </tr>
              <tr>
                <td width="45%">
                  <el-form-item  label="预约人姓名:" prop="at_people_name">
                    <el-input v-model="dataObj.at_people_name"  placeholder="请输入男方姓名"  style="width: 250px;" ></el-input>
                  </el-form-item>
                </td>
                <td width="4%">&nbsp;</td>
                <td width="40%">
                  <el-form-item  label="身份证号:" prop="at_people_idcard">
                    <el-input v-model="dataObj.at_people_idcard"  placeholder="请输入男方身份证号"  style="width: 250px;" ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td width="45%">
                  <el-form-item  label="手机号码:" prop="at_people_tel">
                    <el-input v-model="dataObj.at_people_tel"  placeholder="请输入手机号码"  style="width: 250px;" ></el-input>
                  </el-form-item>
                </td>
                <td width="4%">&nbsp;</td>
                <td width="40%">
                  <div style="display: flex;justify-content: left;align-items: center;">
                    <el-form-item   label="短信校验码:" prop="at_verification_code">
                      <el-input maxlength="6"  v-model="dataObj.at_verification_code" placeholder="请输入" style="width:250px"></el-input>
                    </el-form-item>
                    <el-link type="primary" v-bind:disabled="smsIsDisabled" v-on:click="getSmsCode"  class="code" style="line-height: 25px;margin-bottom: 22px;margin-left: 5px;width: 80px">{{smsText}}</el-link>

                  </div>
                </td>

              </tr>


              <el-form-item style="text-align: right;padding-top: 30px;margin-right: -50px">
                <el-button type="primary" @click="onSubmit('dataObj')">立即预约
                </el-button>
              </el-form-item>
            </table>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      title="实名认证提示"
      :visible.sync="smDialogShow"
      width="400px"
      :before-close="handleClose">
      <span>根据政策规定，在线申办业务，需要实名认证！请选择：<br />1、点击【确定】跳转到实名认证页面<br />2、点击【取消】返回上一级页面</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="sureClose">确 定</el-button>
  </span>
    </el-dialog>

    <div class="clear"></div>
    <footers></footers>

  </div>
</template>
<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  export default {

    components:{
      headers,fixedDiv,footers
    },
    data() {

      let _self=this;
      return {

        clauseShow:false,
        radio:'1',
        num:1,
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e6
          }
        },
        applyName:'',
        showDate:'',
        serviceCatagoryList:[],
        man_document_type_name:'',
        woman_document_type_name:'',
        loginPerson:{
          person_name:'',
          person_uid:'',
          person_tel:'',
          isCertification:'',
          idcardPicFront:'',
          idcardPicBack:'',
          userIdcardAddress:'',
          userNationsId:'',
          userNations:'',
          photo_id:'',
        },
        dataObj:{
          serviceCatagoryName:'',
          isolation:'0',
          people_num:'1',
          into_time:'',
          travel_mode:'',
          travelModeName:'',
          travelModePicker:'',
          at_verification_code:'',
          at_people_tel:'',
          at_people_idcard:'',
          at_people_id:'',
          at_people_name:'',
          begin_time:'',
          end_time:'',
          at_day_type:'',
          work_remark:'',
          at_date:'',
          at_catagory:'1',
          osi_id:'',
          party_id:'',
          service_catagory:'',
          service_code:'funeral',
          org_services:'funeral',
          window_id:'',
          work_address:'',
          work_tel:'',
          at_memo:'',
          at_status_remark:'',
        },

        rules: {
          'applyName':[{required:true,message:'请选择办事单位',tigger:'change'}],
          'serviceCatagoryName':[{required:true,message:'请选择业务分类',tigger:'change'}],
          'travel_mode':[{required:true,message:'请选择出行方式',tigger:'change'}],
          'at_verification_code':[{required:true,message:'验证码不能为空',tigger:'blur'}],
          'man_document_type':[{required:true,message:'请选择证件类型',tigger:'change'}],
          'woman_document_type':[{required:true,message:'请选择证件类型',tigger:'change'}],
          'at_date':[{required:true,message:'请选择预约日期',tigger:'blur'}],
          'man_idcard':[{required:true,validator:this.checkUid,tigger:'blur'}],
          'woman_idcard':[{required:true,validator:this.checkUid,tigger:'blur'}],
          'at_people_idcard':[{required:true,validator:this.checkUid,tigger:'blur'}],
          'man_name':[{required:true,message:'请输入男方姓名',tigger:'blur'}],
          'at_people_name':[{required:true,message:'请输入预约人姓名',tigger:'blur'}],
          'woman_name':[{required:true,message:'请输入男方姓名',tigger:'blur'}],
          'man_tel':[{required:true ,validator:this.checkPhoneNumber,tigger:'blur'}],
          'woman_tel':[{required:true ,validator:this.checkPhoneNumber,tigger:'blur'}],
          'at_people_tel':[{required:true ,validator:this.checkPhoneNumber,tigger:'blur'}],
        },
        condition:'',
        active: 'publicIndex',

        props: {
          lazy: true,
          checkStrictly:true,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
                if (response.status === 200 && response.data.code === 200) {
                  const nodes = Object.values(response.data.data).map(function (e) {
                    return {label: e.name, value: e.code, level: 0, leaf: level >= 2}
                  })
                  resolve(nodes);
                } else {
                  resolve(nodes);
                }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        title:'',
        smDialogShow:false,
        fullscreenLoading: false,
        selectedRegion:[],
        infoData:{},
        tzgg:[],
        travelModeList:[],
        smsText:'发送短信',
        bannerTitle:'殡葬业务',
        smsIsDisabled:true,
        zcwj:[],
        idTypeList:[],
        orgTypeList:[],
        SocialTypeList:[],
        yggs:[],
        applyNameList:[],
      }
    } ,
    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      }
    },
    mounted(){

    },
    created(){

      if(this.$route.query){
        this.dataObj.service_code=this.$route.query.service_code;//业务类型编号
      }

      this.loadPersonInfo();
      this.countDown();
      this.title= this.$route.query.title;
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      setAppointment(){
        const h = this.$createElement;
        this.$msgbox({
          title: '消息',
          message:  '您即将预约'+this.showDate+"【"+this.bannerTitle+"】业务，请点击【确认】按钮进入预约流程!",
          showCancelButton: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              done();
              instance.confirmButtonLoading = false;
              this.setAppointmentYes();
            } else {
              done();
            }
          }
        })
      },
      handleChange(value) {
        console.log(value);
      },

      handleClick(tab, event) {
        //异步获取数据
        this.initNews(tab.name);
      },
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.setAppointment();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      clauseClose(){
        this.clauseShow=false;
      },
      close(value){
        if (value==1){
          this.urlTo("home")
        }else {

        }

      },
      handleClose(){
        this.smDialogShow=false;
        this.$router.back()
      },
      countDown(times){
        var time;
        if(times){
          time=times;
        }else{
          time=this.$cookies.get("time2")
          if(!time){
            this.smsIsDisabled=false;
            return;
          }
        }
        time=time-1;
        this.$cookies.set("time2",time,time+"s")
        if(time<=0){
          this.smsIsDisabled=false;
          this.smsText="发送短信";
          this.$cookies.remove("time2")
          return
        }else{
          this.smsText=time+"秒"
          var t=this;
          setTimeout(function() {
            t.countDown(time);
          },1000)
        }

      },
      sureClose(){
        this.smDialogShow=false;
        this.urlTo('peopleCertification');
      },
      setAppointmentYes() {

        this.fullscreenLoading = true;



        // return false;
        const options={appointContent: this.dataObj}
        var t=this;
        this.$https.post("api/ywt/appointment/saveAppo.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.fullscreenLoading = false;
            var msg="";
            msg=msg+"业务名称："+t.bannerTitle+"\n";
            msg=msg+"预约日期："+t.showDate+"\n";
            msg=msg+"咨询电话："+t.dataObj.work_tel+"\n";
            msg=msg+"办公地址："+t.dataObj.work_address+"\n";
            msg=msg+"预约说明："+t.dataObj.work_remark+"\n";
            this.$message({
                type:'success',
                message: '预约成功'+msg,
                confirmButtonColor:"#199DFA",
                messageAlign:"left",
                className:"dialogCssSelf"
              },
              t.urlTo("home")
            )
          } else {
            this.fullscreenLoading = false;
            //弹框成功提示，并返回登录页面
            this.$message({
              message: '预约失败'+response.data.data.msg,
              messageAlign:"left",
              confirmButtonColor:"#199DFA",
            })
            return false;
          }
        })
      },
      getSmsCode() {
        this.smsIsDisabled=true;
        if(this.dataObj.at_people_tel==''){
          this.$message.error("请输入联系电话");
          this.smsIsDisabled=false;
          return false;
        }
        //校验联系电话码格式
        let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.dataObj.at_people_tel)) {
          this.$message.error("请输入正确的联系电话");
          this.smsIsDisabled=false;
          return;
        }
        this.$https.post("api/pu/getTelCode.do",{tel:this.dataObj.at_people_tel},response=>{
          if (response.status === 200 && response.data.code===200) {
            this.$message.success("短信校验码发送成功，10分钟内有效");
            //倒计时
            this.countDown(120);
          } else {
            this.smsIsDisabled=false;
            this.$message.error(response.data.msg);
          }
        })
      },
      subDate(date){
        var submit1 = date.substring(0,4);
        var submit2 = date.substring(4,6);
        var submit3 = date.substring(6,8);
        this.showDate=submit1+'-'+submit2+'-'+submit3;
      },
      onChange(index) {
        //  Notify({ type: 'primary', message: index+"_"});
        this.$router.push(index);
      },
      gotoReg(){
        this.$router.push("/peopleReg");

      },
      checkPhoneNumber(rule, value, callback) {
        const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
        if (!value) {
          return callback(new Error('请填写联系电话！'))
        } else if (!reg.test(value)) {
          return callback(new Error('请填写正确的联系电话！'))
        }else{
          callback()
        }
      },

      loadPersonInfo(){
        var tt=this;
        this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            if( null!=response.data.data  && response.data.data.isCertification == '1'){
              tt.dataObj.at_people_tel=response.data.data.userTel;
              tt.dataObj.at_people_idcard=response.data.data.userIdcard;
              tt.dataObj.at_people_id=response.data.data.userId;
              tt.dataObj.at_people_name=response.data.data.userName;
              tt.getServiceApply();
              tt.getServiceCatagoryList();
              tt.getTravelModeList();
            }else{
              //跳转去实名认证
              tt.smDialogShow=true;
            }
          } else {
            tt.$router.push({path:'/peopleLogin'});
          }
        });
      },
      test(value){
        alert(value)
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      getServiceApply(){
        const options={osi_catagory:'funeral'}
        var t=this;
        this.$https.post("/api/orgservice/getOrgServiceInfoList.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            if(response.data.data !=null && response.data.data.length>0){
              t.applyNameList=response.data.data
            }
          }
        });
      },

      getDictData(){
        let data={
          types:[
            'open_document_type'
          ]
        };
        this.$https.post('api/ywt/base/getDictDataNoEmpty.do',data,response=>{
          if (response.data.code===200){
            this.idTypeList=response.data.data.open_document_type;
            this.$util.readData(response.data.data,this)
          }
        })
      },
      getServiceCatagoryList(){
        const options={service_catagory:'funeral'}
        var t=this;
        this.$https.post("/api/ywt/getSaEnumType.do",options,response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            if(response.data.data.data !=null && response.data.data.data.length>0){
              t.serviceCatagoryList = response.data.data.data;
            }
          }
        })
      },
      getTravelModeList(){
        const options={service_catagory:'travelMode'}
        var t=this;
        this.$https.post("/api/ywt/getSaEnumType.do",options,response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            if(response.data.data.data !=null && response.data.data.data.length>0){
              t.travelModeList = response.data.data.data
            }
          }
        })
      },
      onApplyConfirm(value){
        if(value){
          this.applyName= value.osiName;
          this.dataObj.osi_id=value.osiId;
          this.dataObj.work_address=value.workAddress;
          this.dataObj.work_tel=value.workTel;
          this.dataObj.work_remark=value.workRemark;
          this.dataObj.party_id=value.partyId;
        }else{
          this.applyName='';
          this.dataObj.osi_id='';
          this.dataObj.work_address='';
          this.dataObj.work_tel='';
          this.dataObj.work_remark='';
          this.dataObj.party_id='';
        }
        this.showApplyNamePicker = false;
      },
      checkUid(rule,value,callback){
        callback(this.$util.func.uid.check(value))
      },
      check(uid) {
        if(!uid){
          return "请输入身份证号"
        }
        //检查身份证号码
        var arrVerifyCode = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
        var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        var Checker = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
        if (uid.length != 15 && uid.length != 18) {
          //return "身份证号共有15位或18位"
          return "身份证号共有15位或18位"
        }
        uid = uid.replace("x", "X");
        var Ai = uid.length == 18 ? uid.substring(0, 17) : uid.slice(0, 6) + "19" + uid.slice(6, 16);
        if (!/^\d+$/.test(Ai)) {
          //return "身份证除最后一位外，必须为数字！"
          return "身份证格式错误！"
        }
        var yyyy = Ai.slice(6, 10), mm = Ai.slice(10, 12) - 1, dd = Ai.slice(12, 14);
        var d = new Date(yyyy, mm, dd), now = new Date();
        var year = d.getFullYear(), mon = d.getMonth(), day = d.getDate();
        if (year != yyyy || mon != mm || day != dd || d > now || year < 1800) {
          //return "身份证输入错误！"
          return "身份证格式错误！"
        }
        for (var i = 0, ret = 0; i < 17; i++) {
          ret += Ai.charAt(i) * Wi[i]
        }
        Ai += arrVerifyCode[ret %= 11];

        if (uid.length == 18 && uid != Ai) {
          return "身份证格式错误！";
        }
      },
      urlTo2(url,params){
        this.$message({
          message: '暂未开放',
          type: 'warning'
        });
        // this.$router.push({path:url,query:params||{}});
      }

    }
  }



</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/appointment/FuneralAppointment.vue